import React, { useState } from 'react';
import { useLanguage } from '../LanguageContext';
import { useScrollReveal } from '../hooks/useScrollReveal';

const UltraLongRange = () => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState(0);
  const ref = useScrollReveal(['.ultra-text h2', '.ultra-text p', '.ultra-region-card', '.ultra-image'], { stagger: 0.07 });
  const regions = t.ultra.regions;

  return (
    <section id="inspiration" className="ultra-section" ref={ref}>
      <div className="ultra-content">
        <div className="ultra-text">
          <h2>{t.ultra.heading}</h2>
          <p>{t.ultra.paragraph}</p>
          {t.ultra.direct && <p className="ultra-direct">{t.ultra.direct}</p>}
          <div className="ultra-region-cards">
            {regions.map((r, i) => (
              <button key={r.name} type="button"
                className={`ultra-region-card ${selected === i ? 'active' : ''}`}
                onClick={() => setSelected(i)}
              >{r.name}</button>
            ))}
          </div>
          <p className="ultra-region-description">{regions[selected].description}</p>
        </div>
        <div className="ultra-image">
          <img src={regions[selected].image} alt={regions[selected].name} />
          <div className="ultra-image-label">{regions[selected].name}</div>
        </div>
      </div>
    </section>
  );
};

export default UltraLongRange;
